var _defs, _path, _path2, _rect, _rect2, _rect3, _path3, _rect4, _rect5, _polygon, _path4, _path5, _path6, _path7, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorizGrayCroppedRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 324.99 36.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #231f20;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.5,24.48c0,1.24-1.01,2.25-2.25,2.25s-2.25-1.01-2.25-2.25V2.23h-10v22.25c0,6.77,5.48,12.25,12.25,12.25s12.25-5.48,12.25-12.25V0h-10v24.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.5,0v23.23c0,1.38-1.12,2.5-2.5,2.5h-2.5V0h-10v35.73h12.5c6.9,0,12.5-5.6,12.5-12.5V0h-10Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 89.5,
    width: 10,
    height: 35.73
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 122.5,
    width: 10,
    height: 35.73
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 107.5,
    width: 10,
    height: 35.73
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,0v24.23c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5V0H0v24.23c0,6.9,5.6,12.5,12.5,12.5s12.5-5.6,12.5-12.5V0s-10,0-10,0Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 246.99,
    width: 10,
    height: 35.73
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 261.99,
    width: 10,
    height: 35.73
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "286.49 0 276.49 0 276.49 35.73 297.49 35.73 297.49 25.73 286.49 25.73 286.49 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152,0v24.23c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5V0h-10v24.23c0,6.9,5.6,12.5,12.5,12.5s12.5-5.6,12.5-12.5V0h-10Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314.78,0l.05.15c.1.27.16.55.16.85v23.23c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5V2.23h-10v22c0,6.9,5.6,12.5,12.5,12.5s12.5-5.6,12.5-12.5V1c0-.34-.02-.67-.04-1h-10.17,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.49,24.23c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5V0h-10v24.23c0,6.9,5.6,12.5,12.5,12.5s12.5-5.6,12.5-12.5V2.23h-10v22Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.99,0v24.23c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5V0h-10v24.23c0,6.9,5.6,12.5,12.5,12.5s12.5-5.6,12.5-12.5V0h-10Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 198.74,
    width: 10,
    height: 35.73
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizGrayCroppedRight);
export default __webpack_public_path__ + "static/media/horiz_gray-cropped-right.e9722872deef27b8c92b9dc3587a2f08.svg";
export { ForwardRef as ReactComponent };